// Skills Section Logo's
import htmlLogo from './assets/tech_logo/html.png';
import cssLogo from './assets/tech_logo/css.png';
import sassLogo from './assets/tech_logo/sass.png';
import javascriptLogo from './assets/tech_logo/javascript.png';
import reactjsLogo from './assets/tech_logo/reactjs.png';
import reduxLogo from './assets/tech_logo/redux.png';
import nextjsLogo from './assets/tech_logo/nextjs.png';
import tailwindcssLogo from './assets/tech_logo/tailwindcss.png';
import materialuiLogo from './assets/tech_logo/materialui.png';
import bootstrapLogo from './assets/tech_logo/bootstrap.png';
import nodejsLogo from './assets/tech_logo/nodejs.png';
import expressjsLogo from './assets/tech_logo/express.png';
import nestjsLogo from './assets/tech_logo/nestjs.png';
import mysqlLogo from './assets/tech_logo/mysql.png';
import mongodbLogo from './assets/tech_logo/mongodb.png';
import firebaseLogo from './assets/tech_logo/firebase.png';
import cLogo from './assets/tech_logo/c.png';
import pythonLogo from './assets/tech_logo/python.png';
import swaggerLogo from './assets/tech_logo/swagger.png';
import TypescriptLogo from './assets/tech_logo/typescript.png';
import gitLogo from './assets/tech_logo/git.png';
import githubLogo from './assets/tech_logo/github.png';
import vscodeLogo from './assets/tech_logo/vscode.png';
import postmanLogo from './assets/tech_logo/postman.png';
import mcLogo from './assets/tech_logo/mc.png';
import figmaLogo from './assets/tech_logo/figma.png';
import netlifyLogo from './assets/tech_logo/netlify.png';
import vercelLogo from './assets/tech_logo/vercel.png';
import postgreLogo from './assets/tech_logo/postgre.png';
import s3Logo from './assets/tech_logo/aws-s3.png';
import ec2Logo from './assets/tech_logo/aws-ec2.png';
import textractLogo from './assets/tech_logo/aws-textract.png';
import renderLogo from './assets/tech_logo/render.png';

// Experience Section Logo's
import internshipLogo from './assets/company_logo/internship.png';
import icgLogo from './assets/company_logo/icg.png';
import freelanceLogo from './assets/company_logo/freelance.png';
import kelltonLogo from './assets/company_logo/kellton.png';
import remarkLogo from './assets/company_logo/remark.png';
import queues from './assets/company_logo/queues.jpeg';

// Education Section Logo's
import iitPatnaLogo from './assets/education_logo/iitPatna.png';
import bbdLogo from './assets/education_logo/bbd_logo.png';
import interLogo from './assets/education_logo/crtsvm.png';
import highLogo from './assets/education_logo/high.png';

// Project Section Logo's
import emoonedsLogo from './assets/work_logo/emooneds.png';
import freelancesLogo from './assets/work_logo/freelance.png';
import sonyLivLogo from './assets/work_logo/sonyLiv.png';
import zee5Logo from './assets/work_logo/zee5.png';
import kelltonEcommerceLogo from './assets/work_logo/K-Ecommerce.png';
import pacificLogo from './assets/work_logo/pacific.png';

//Certification Section Logo's
import completedcourseLogo from './assets/certification_logo/completedCourseGenAi.png';
import exploreLogo from './assets/certification_logo/Explore.png'
import inspectLogo from './assets/certification_logo/InspectRich.png'
import devLogo from './assets/certification_logo/dev.png';
import buildLogo from './assets/certification_logo/build.png';
import promptLogo from './assets/certification_logo/prompt.png';
import isro1Logo from './assets/certification_logo/ISRO 1.png';
import isro2Logo from './assets/certification_logo/ISRO 2.png';
import awsBusinessLogo from './assets/certification_logo/awsBusiness.png';
import awsCloudLogo from './assets/certification_logo/awsCloud.png';
import Remark_IntershipLogo from './assets/certification_logo/Remark_Intership.png';
import mtaLogo from './assets/certification_logo/microsoft.png'
import IS_intershipLogo from './assets/certification_logo/CertificateOfInternship-IS.png';
import IS_TrainingLogo from './assets/certification_logo/CertificateOfTraining-IS.png';
import IS_offer from './assets/certification_logo/IS_OfferLetter.png'
import responsiveEcommerceLogo from './assets/certification_logo/Responsive_E_Commerce.png';
import KelltonTraineLogo from './assets/certification_logo/Kellton_Traine.png';
import kelltonTrainingLogo from './assets/certification_logo/Kellton_TrainingCompleted.png';
import kelltonRelievinLetterLogo from './assets/certification_logo/Kellton_RelievinLetter.png';
import kelltonExperienceLogo from './assets/certification_logo/Kellton_experience.png';
import MithuExperienceLogo from './assets/certification_logo/MithuPicture_ExperienceLetter.png';

export const SkillsInfo = [
  {
    title: 'Frontend',
    skills: [
      { name: 'HTML', logo: htmlLogo },
      { name: 'CSS', logo: cssLogo },
      { name: 'SASS', logo: sassLogo },
      { name: 'JavaScript', logo: javascriptLogo },
      { name: 'React JS', logo: reactjsLogo },
      { name: 'Redux', logo: reduxLogo },
      { name: 'Next JS', logo: nextjsLogo },
      { name: 'Tailwind CSS', logo: tailwindcssLogo },
      { name: 'Material UI', logo: materialuiLogo },
      { name: 'Bootstrap', logo: bootstrapLogo },
    ],
  },
  {
    title: 'Backend',
    skills: [
      { name: 'Node JS', logo: nodejsLogo },
      { name: 'Express JS', logo: expressjsLogo },
      { name: 'Nest JS', logo: nestjsLogo },
      { name: 'MySQL', logo: mysqlLogo },
      { name: 'MongoDB', logo: mongodbLogo },
      { name: 'Firebase', logo: firebaseLogo },
      { name: 'PostgreSQL', logo: postgreLogo },
    ],
  },
  {
    title: 'Languages',
    skills: [
      { name: 'C', logo: cLogo },
      { name: 'JavaScript', logo: javascriptLogo },
      { name: 'Typescript', logo: TypescriptLogo },
      { name: 'Python', logo: pythonLogo },
    ],
  },
  {
    title: 'Cloud / DevOps',
    skills: [
      { name: 'AWS S3', logo: s3Logo },
      { name: 'AWS EC2', logo: ec2Logo },
      { name: 'AWS Textract', logo: textractLogo },
      { name: 'Render', logo: renderLogo },
    ],
  },
  {
    title: 'Tools',
    skills: [
      { name: 'Git', logo: gitLogo },
      { name: 'GitHub', logo: githubLogo },
      { name: 'VS Code', logo: vscodeLogo },
      { name: 'Postman', logo: postmanLogo },
      { name: 'Compass', logo: mcLogo },
      { name: 'Vercel', logo: vercelLogo },
      { name: 'Netlify', logo: netlifyLogo },
      { name: 'Figma', logo: figmaLogo },
      { name: 'Swagger', logo: swaggerLogo },
    ],
  },
];

export const experiences = [
  {
    id: 1,
    img: icgLogo,
    role: "Full Stack Developer",
    company: "ICG Technologies Pvt Ltd",
    date: "Oct 2025 - Present",
    desc: "Working as a Full Stack Developer, building scalable and responsive web applications using Next.js, HTML, CSS, Bootstrap, and Material UI. Collaborating with designers to convert Figma wireframes into interactive interfaces. Developing backend services using Node.js, NestJS, and MongoDB. Implemented file storage using AWS S3 and handled application deployment and hosting using Render.",
    skills: [
      "HTML",
      "CSS",
      "Next.js",
      "Bootstrap",
      "Figma",
      "Material UI",
      "Node.js",
      "NestJS",
      "MongoDB",
      "AWS S3",
      "Render"
    ],
  },
  {
    id: 2,
    img: queues,
    role: "Full Stack Developer",
    company: "Queues Technologies Pvt Ltd",
    date: "Sep 2025 - Present",
    desc: "Working as a Full Stack Developer, developing responsive web applications and reusable UI components. Converting Figma designs into high-quality frontends using Next.js and modern UI frameworks. Building backend APIs using Node.js, NestJS, and MongoDB.",
    skills: [
      "HTML",
      "CSS",
      "Next.js",
      "Bootstrap",
      "Figma",
      "Material UI",
      "Node.js",
      "NestJS",
      "MongoDB"
    ],
  },
  {
    id: 3,
    img: freelanceLogo,
    role: "Software Engineer - Backend Developer",
    company: "Mithu Picture (Contract-Based)",
    date: "Nov 2024 - Jun 2025",
    desc: "Worked as a Backend Developer, building scalable server-side applications using Node.js and Express.js. Designed RESTful APIs, managed MongoDB databases, and implemented secure authentication and efficient data handling. Collaborated with teams to improve performance and reliability.",
    skills: [
      "Node.js",
      "Express.js",
      "React.js",
      "TypeScript",
      "Tailwind CSS",
      "MongoDB"
    ],
  },
  {
    id: 4,
    img: kelltonLogo,
    role: "Software Engineer - Full Stack Developer (MERN & PERN)",
    company: "Kellton Tech",
    date: "Feb 2022 - Oct 2024",
    desc: "Worked as a Full Stack Developer using MERN and PERN stacks. Developed scalable backend services and dynamic frontend applications. Built RESTful APIs, integrated MongoDB and PostgreSQL databases, and created responsive UIs using React and Next.js. Ensured high performance and security across applications.",
    skills: [
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "PostgreSQL",
      "Next.js",
      "NestJS",
      "TypeScript",
      "PWA",
      "Jest",
      "Swagger",
      "Postman"
    ],
  },
  {
    id: 5,
    img: remarkLogo,
    role: "Frontend Developer",
    company: "Remark Skill (Microsoft Technology Associate)",
    date: "Jun 2021 - Jul 2021",
    desc: "Worked as a Frontend Developer, building responsive UI components using HTML, CSS, JavaScript, and Bootstrap. Collaborated with designers to convert Figma wireframes into user-friendly and interactive web interfaces.",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "Bootstrap"
    ],
  },
];

export const education = [
  {
    id: 0,
    img: iitPatnaLogo,
    school: "Indian Institute of Technology (IIT), Patna",
    date: "2025 - Present",
    grade: "Pursuing",
    desc: "Currently pursuing Master of Technology (M.Tech) in Artificial Intelligence and Data Science from IIT Patna. Gaining advanced knowledge in Machine Learning, Deep Learning, Data Science, and AI-driven systems. Actively working on real-world projects and research to strengthen problem-solving and analytical skills.",
    degree: "Master of Technology - M.Tech (Artificial Intelligence and Data Science)",
  },
  {
    id: 1,
    img: bbdLogo,
    school: "Babu Banarasi Das University, Lucknow",
    date: "Aug 2018 - Jun 2022",
    grade: "8.51 CGPA",
    desc: "Completed Bachelor's of Technology (B.Tech) in Computer Science and Engineering. Built a strong foundation in Data Structures, Algorithms, Object-Oriented Programming, DBMS, Web Development, and Software Engineering. Participated in technical workshops and events to enhance practical knowledge and skills.",
    degree: "Bachelor of Technology - B.Tech (CSE)",
  },
  {
    id: 2,
    img: interLogo,
    school: "Chokhraj Tulsyan Saraswati Vidya Mandir Inter College, Siswa Bazar",
    date: "Apr 2017 - Mar 2018",
    grade: "65%",
    desc: "Completed Class 12 under UP Board with a focus on Physics, Chemistry, and Mathematics (PCM).",
    degree: "UP Board (XII) - PCM",
  },
  {
    id: 3,
    img: highLogo,
    school: "Mahatma Gandhi Inter College, Siswa Bazar",
    date: "Apr 2015 - Mar 2016",
    grade: "75.5%",
    desc: "Completed Class 10 under UP Board with a focus on Science and foundational subjects.",
    degree: "UP Board (X)",
  },
];

export const projects = [
  {
    id: 0,
    title: "ICG Infotech Platform",
    description: "Developed and maintained a full-stack web platform for ICG Infotech, focusing on scalable UI components and backend services. Integrated AWS S3 for file storage and deployed applications using Render. Worked on responsive UI and API development for seamless user experience.",
    image: icgLogo,
    tags: ["Next.js", "Node.js", "NestJS", "MongoDB", "AWS S3", "Render", "Material UI"],
    category: "Freelance",
    duration: "Oct 2025 - Present",
  },
  {
    id: 1,
    title: "Queues Technologies Platform",
    description: "Built and maintained scalable web applications for Queues Technologies. Developed responsive frontend using Next.js and implemented backend APIs with Node.js and NestJS. Focused on performance optimization and reusable component architecture.",
    image: queues,
    tags: ["Next.js", "Node.js", "NestJS", "MongoDB", "Bootstrap", "REST APIs"],
    webapp: "https://queues.co.in/",
    category: "Freelance",
    duration: "Sep 2025 - Oct 2025",
  },
  {
    id: 2,
    title: "Mithu Picture",
    description: "MithuPicture is a creative services platform offering graphic design, motion graphics, and video editing solutions. Developed scalable backend services, RESTful APIs, and handled database management to support seamless collaboration and service requests.",
    image: freelancesLogo,
    tags: ["Node.js", "Express.js", "TypeScript", "React.js", "MongoDB", "REST APIs"],
    category: "Freelance",
    duration: "Nov 2024 - Jun 2025",
  },
  {
    id: 3,
    title: "Emoneeds",
    description: "Developed and maintained backend systems, building secure and scalable RESTful APIs. Managed MongoDB database and implemented efficient data handling and authentication mechanisms.",
    image: emoonedsLogo,
    tags: ["Node.js", "MongoDB", "Express.js", "TypeScript", "REST APIs"],
    webapp: "https://emoneeds.co/",
    category: "Client",
    duration: "Sep 2024 - Oct 2024",
  },
  {
    id: 4,
    title: "Pacific Group",
    description: "Developed backend services for a mall engagement platform with features like loyalty programs, booking systems, and user engagement tools. Focused on scalability and performance.",
    duration: "Mar 2024 - Sep 2024",
    tags: ["Node.js", "Express.js", "TypeScript", "PostgreSQL", "REST APIs"],
    category: "Client",
    image: pacificLogo,
  },
  {
    id: 5,
    title: "Sony Liv CMS",
    description: "Worked on CMS platform for Sony Liv to manage and distribute digital content. Developed APIs, handled database operations, and contributed to scalable backend architecture.",
    duration: "Aug 2023 - Mar 2024",
    tags: ["Node.js", "Express.js", "TypeScript", "MongoDB", "Swagger", "Unit Testing"],
    webapp: "https://www.sonyliv.com/",
    category: "Client",
    image: sonyLivLogo,
  },
  {
    id: 6,
    title: "Kellton E-Commerce",
    description: "Developed frontend features for an e-commerce platform with focus on user experience, responsiveness, and performance optimization.",
    duration: "Mar 2023 - Aug 2023",
    tags: ["React.js", "Next.js", "TypeScript", "Material UI"],
    category: "Client",
    image: kelltonEcommerceLogo,
  },
  {
    id: 7,
    title: "ZEE5 CMS",
    description: "Worked on a large-scale CMS platform for ZEE5, enabling content management and distribution across multiple devices. Focused on backend services and API integration.",
    duration: "Aug 2022 - Mar 2023",
    tags: ["React.js", "Node.js", "Express.js", "MongoDB"],
    webapp: "https://www.zee5.com/",
    category: "Client",
    image: zee5Logo,
  }
];

export const certifications = [
  {
    title: "Completed Certificate Gen AI Academy",
    issuer: "Google",
    year: 2025,
    logo: completedcourseLogo, // Coursera logo URL
    link: "https://certificate.hack2skill.com/user/GenAI5-28M/2025H2S04GENAI-A01055", // Replace with the actual link
  },
  {
    title: "Explore Generative AI with the Gemini API in Vertex AI",
    issuer: "Google",
    year: 2025,
    logo: exploreLogo, // Coursera logo URL
    link: "https://www.cloudskillsboost.google/public_profiles/c0e2f2d8-7b4a-42e3-b7c2-399333789db5/badges/15768565", // Replace with the actual link
  },
  {
    title: "Inspect Rich Documents with Gemini Multimodality and Multimodal RAG",
    issuer: "Google",
    year: 2025,
    logo: inspectLogo, // Coursera logo URL
    link: "https://www.cloudskillsboost.google/public_profiles/c0e2f2d8-7b4a-42e3-b7c2-399333789db5/badges/15790766", // Replace with the actual link
  },
  {
    title: "Develop GenAI Apps with Gemini and Streamlit Skill Badge",
    issuer: "Google",
    year: 2025,
    logo: devLogo, // Coursera logo URL
    link: "https://www.cloudskillsboost.google/public_profiles/c0e2f2d8-7b4a-42e3-b7c2-399333789db5/badges/15468791", // Replace with the actual link
  },
  {
    title: "Build Real World AI Applications with Gemini and Imagen Skill Badge",
    issuer: "Google",
    year: 2025,
    logo: buildLogo, // freeCodeCamp logo URL
    link: "https://www.cloudskillsboost.google/public_profiles/c0e2f2d8-7b4a-42e3-b7c2-399333789db5/badges/15391630", // Replace with the actual link
  },
  {
    title: "Prompt Design in Vertex AI Skill Badge",
    issuer: "Google",
    year: 2025,
    logo: promptLogo, // Udemy logo URL
    link: "https://www.cloudskillsboost.google/public_profiles/c0e2f2d8-7b4a-42e3-b7c2-399333789db5/badges/15372710", // Replace with the actual link
  },
  {
    title: "IIRS Outreach Program on Remote Sensing and GIS",
    issuer: "ISRO",
    year: 2025,
    logo: isro1Logo, // Udemy logo URL
    link: "https://drive.google.com/file/d/16WAqBClIzoqqbq4dX5Aezz2Gq6wwgPJK/view?usp=drive_link", // Replace with the actual link
  },
  {
    title: "Space Science And Technology Awareness Training (START)",
    issuer: "ISRO",
    year: 2025,
    logo: isro2Logo, // Udemy logo URL
    link: "https://drive.google.com/file/d/1XgS6DfKSBHo9U8yWEYrZnxY8_yVj1qE1/view?usp=drive_link", // Replace with the actual link
  },
  {
    title: "AWS Business Accredited",
    issuer: "AWS",
    year: 2021,
    logo: awsBusinessLogo, // Udemy logo URL
    link: "https://www.credly.com/badges/44fc8dc1-13c8-4ee9-aee1-770636247020/linked_in_profile", // Replace with the actual link
  },
  {
    title: "AWS Partner: Cloud Economics Essentials",
    issuer: "AWS",
    year: 2021,
    logo: awsCloudLogo, // Udemy logo URL
    link: "https://www.credly.com/badges/d82fe1e6-b2bf-4845-9b31-7baecbd5d295/linked_in?t=rilm2u", // Replace with the actual link
  },
  {
    title: "Microsoft Technology Associate",
    issuer: "Microsoft",
    year: 2021,
    logo: mtaLogo, // Udemy logo URL
    link: "https://drive.google.com/file/d/1i5PbFMgJWrACCx6_nWrEpQDw0NSlEDVp/view?usp=drive_link", // Replace with the actual link
  },
  {
    title: "Certificate of Training",
    issuer: "CIT",
    year: 2025,
    logo: IS_TrainingLogo,
    link: "https://drive.google.com/file/d/1AWoJmD2bFQc2NxaI__KW2m_xrrG39Mra/view?usp=drive_link", // Replace with the actual link
  },
  {
    title: "Certificate of Internship",
    issuer: "CIT",
    year: 2025,
    logo: IS_intershipLogo,
    link: "https://drive.google.com/file/d/1pQ9qkeTWRY7CMGIYLDhOPP8zLcPAXPtH/view?usp=drive_link", // Replace with the actual link
  },
  {
    title: "Responsive E-Commerce Website and Development",
    issuer: "CIT",
    year: 2025,
    logo: responsiveEcommerceLogo,
    link: "https://drive.google.com/file/d/1jrisGdvJsxc0UpLS5pIAqCgVlf3v4Kou/view?usp=drive_link", // Replace with the actual link
  },
  {
    title: "Intership Studio Offer Letter",
    issuer: "CIT",
    year: 2025,
    logo: IS_offer,
    link: "https://drive.google.com/file/d/1ucQX7FSVmXhLZJsIIi4n5mec44wz_72w/view?usp=drive_link", // Replace with the actual link
  },
  {
    title: "Mithu Picture Experience Letter",
    issuer: "Mithi Picture",
    year: 2025,
    logo: MithuExperienceLogo,
    link: "https://drive.google.com/file/d/10m15zq3xpIYJTXxsqc5KmRjGetL3c6gv/view?usp=drive_link", // Replace with the actual link
  },
  {
    title: "Kellton Relieving Letter",
    issuer: "Kellton",
    year: 2024,
    logo: kelltonRelievinLetterLogo,
    link: "https://drive.google.com/file/d/1110fBJyXab06HatgCKJbAARvaOV_SmTb/view?usp=drive_link", // Replace with the actual link
  },
  {
    title: "Kellton Experience Letter",
    issuer: "Kellton",
    year: 2024,
    logo: kelltonExperienceLogo,
    link: "https://drive.google.com/file/d/1sF_AfesFdpu1H-aGCZPTSsr64UDTbjxJ/view?usp=drive_link", // Replace with the actual link
  },
  {
    title: "Kellton Training Completion Certificate",
    issuer: "Kellton",
    year: 2022,
    logo: kelltonTrainingLogo,
    link: "https://drive.google.com/file/d/1imEjqGYbe4g5QNlVNYs_noE_70PAeBb7/view?usp=drive_link", // Replace with the actual link
  },
  {
    title: "Kellton Training Start Certificate",
    issuer: "Kellton",
    year: 2022,
    logo: KelltonTraineLogo,
    link: "https://drive.google.com/file/d/1yV4HDokNJuhXw74tIhgEGXw5ryXJqWlq/view?usp=drive_link", // Replace with the actual link
  },
  {
    title: "Remarkskill Internship Completion Certificate",
    issuer: "Remark Skill",
    year: 2021,
    logo: Remark_IntershipLogo, // Udemy logo URL
    link: "https://drive.google.com/file/d/1loI0QRIV30lLXrvWuTZwHASpXUzE4Yhn/view?usp=drive_link", // Replace with the actual link
  }
];